import React, { useState } from 'react'
import PopUp from '../../../../Shared/Popup/PopUp';
import TextInput from '../../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';

const AddTechnicianContact = (props) => {

    const [openPopUp, setOpenPopUp] = useState(true);
    const [fullName, setFullName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const handleContact = () => {
        setOpenPopUp(false);
    }

    BtnSubmit
    return (
        <div className='add-technician-contact'>
            <PopUp showPopUp={openPopUp} onClose={() => setOpenPopUp(false)} >
                <div className='main-title'>
                    הוסיפו איש קשר
                    <br />
                    לתיאום עם הטכנאי
                </div>
                <div className='full-name-location'>
                    <TextInput
                        required={true}
                        className='full-name-input'
                        placeholder='שם מלא'
                        type='text'
                        maxLength='10'
                        onChange={(e) => setFullName(e.target.value)}
                        value={fullName}

                    />
                </div>
                <div className='phone-number-location'>
                    <TextInput
                        className='phone-number-input'
                        required={true}
                        placeholder='טלפון נייד'
                        type='number'
                        maxLength='10'
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        value={phoneNumber}
                    />
                </div>

                <BtnSubmit className='button-location' text='הוספה' onclick={handleContact} />

            </PopUp>

        </div>
    )
}

export default AddTechnicianContact